module.exports = "<p>不同尺寸</p>\n";